export function splitPath(
    path: string | null,
    trailingSlash: boolean
): string[] {
    if (path == null)
        return [];

    const pathParts = (path || '').split('?');
    if (pathParts[0].endsWith('/') !== trailingSlash) {
        if (trailingSlash) pathParts[0] += '/';
        else pathParts[0] = pathParts[0].slice(0, -1);
    }
    return pathParts;
}
